import styled from "styled-components";

export const PostsToPrint = styled.div`
  width: 100%;
  .preview-error {
    display: none;
  }
  .preview-performance {
    display: none;
  }
`;

export const PostToPrint = styled.div`
  text-align: center;

  @media print {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const PageBreak = styled.div`
  page-break-before: always;
`;

export const PostName = styled.div`
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 10px;
`;
